import"../../chunk-SDBWQ4EE.js";const t=()=>{try{return new Function('import("")'),!0}catch{return!1}},r=()=>"ontouchstart"in window||navigator.maxTouchPoints>0;export{r as isTouchDevice,t as supportsDynamicImport};
